import { Component, Input } from '@angular/core';

/**
 * Reusable "busy" overlay for any modal / inline editor.
 *
 * Drop it in as the last child of the container you want to gray out and make
 * sure that container is `position: relative`. While [active] is true the whole
 * container is dimmed, desaturated and no longer clickable, so the window stays
 * open but cannot be edited until the save completes.
 */
@Component({
	selector: 'saving-overlay',
	templateUrl: './saving-overlay.component.html',
	styleUrls: ['./saving-overlay.component.scss']
})
export class SavingOverlayComponent {
	@Input() active: boolean = false;
	@Input() message: string = 'Saving...';
}
